import { makeStyles, useTheme } from "@mui/styles";
import { useMediaQuery } from "@mui/material";
import { useRouter } from "found";
import AppLauncherAppBar from "./components/AppLauncherAppBar";
import AppLauncherCard from "./components/AppLauncherCard";
import ArtworkProjectionContext from "../../ArtworkProjectionContext";
import Grid from "@mui/material/Grid";
import React, { useContext } from "react";

import ArtImage from "../../../assets/art.svg";
import DTGImage from "../../../assets/dtg.svg";
import EmbroideryImage from "../../../assets/embroidery.svg";
import HDDPressImage from "../../../assets/dtg.svg";
import HDDReadyImage from "../../../assets/dtg.svg";
import LocalInventoryImage from "../../../assets/pulledStock.svg";
import PulledStockImage from "../../../assets/pulledStock.svg";
import ReceivingImage from "../../../assets/receiving.svg";
import ScreenPrintingImage from "../../../assets/screenPrinting.svg";
import ScreensMadeImage from "../../../assets/screensMade.svg";
import StockStagedImage from "../../../assets/stockStaged.svg";
import VinylImage from "../../../assets/vinyl.svg";

const { REACT_APP_INVENTORY_MANAGEMENT_URL } = process.env;

const useStyles = makeStyles(theme => ({
  container: {
    margin: theme.spacing(3)
  }
}));

const appButtons = [
  {
    location: "/apps/screens-made",
    name: "Screens Made",
    appImage: ScreensMadeImage
  },
  { location: "/apps/receiving", name: "Receiving", appImage: ReceivingImage },
  { location: "/apps/receive-and-locate", name: "Receive and Locate", appImage: ReceivingImage },
  {
    location: "/apps/local-inventory",
    name: "Local Inventory",
    appImage: LocalInventoryImage
  },
  {
    location: `${REACT_APP_INVENTORY_MANAGEMENT_URL}/inventory`,
    name: "Inventory Management",
    appImage: LocalInventoryImage
  },
  {
    location: "/apps/pull-from-stock",
    name: "Pull From Stock",
    appImage: PulledStockImage
  },
  {
    location: "/apps/counting-staging",
    name: "Counting/Staging",
    appImage: StockStagedImage
  },
  {
    location: "/apps/production/embroidery",
    name: "Embroidery",
    appImage: EmbroideryImage
  },
  { location: "/apps/production/dtg", name: "DTG", appImage: DTGImage },
  {
    location: "/apps/production/hdd-press",
    name: "HDD Press",
    appImage: HDDPressImage
  },
  {
    location: "/apps/production/hdd-merging",
    name: "HDD Merging",
    appImage: HDDReadyImage
  },
  {
    location: "/apps/production/transfer-printing/standard",
    name: "Transfer Printing",
    appImage: HDDPressImage
  },
  {
    location: "/apps/production/screen-printing",
    name: "Screen Printing",
    appImage: ScreenPrintingImage
  },
  { location: "/apps/production/vinyl", name: "Vinyl", appImage: VinylImage },
  {
    location: "/apps/production/proofing",
    name: "Proofing",
    appImage: ArtImage
  },
  { location: "/apps/production/art", name: "Art", appImage: ArtImage },
  {
    location: "/apps/check-return-status",
    name: "Check Return Status",
    appImage: ReceivingImage
  },
  {
    location: "/apps/bulk-box-location-setter",
    name: "Bulk Box Location Setter",
    appImage: ReceivingImage
  },
  {
    location: "/apps/bulk-film-location-setter",
    name: "Bulk Film Location Setter",
    appImage: ReceivingImage
  },
  { location: "/apps/art-ready", name: "Art Ready", appImage: ArtImage },
  { location: "/apps/film-check", name: "Film Check", appImage: HDDReadyImage },
  {
    location: "/apps/fix-pieces",
    name: "Fix Pieces",
    appImage: ReceivingImage
  },
  { location: "/apps/art-review", name: "Art Review", appImage: ArtImage },
  {
    location: "/apps/bulk-receiving",
    name: "Bulk Receiving",
    appImage: ReceivingImage
  }
];

const AppLauncher = () => {
  const classes = useStyles();
  const theme = useTheme();
  const { launchArtworkProjection } = useContext(ArtworkProjectionContext);
  const flexAlignment = useMediaQuery(theme.breakpoints.up("md"))
    ? "flex-start"
    : "center";
  const { router } = useRouter();

  const handleAppCardClick = location => {
    if (location.toLowerCase().startsWith("https://")) {
      window.location = location;
    } else {
      router.push(location);
    }
  };

  return (
    <div>
      <AppLauncherAppBar />
      <div className={classes.container}>
        <Grid
          container
          spacing={1}
          justifyContent={flexAlignment}
          alignItems={flexAlignment}
        >
          {appButtons.map(({ location, name, appImage }) => (
            <Grid key={name} item md={4} lg={3} xl={2} sm={6}>
              <AppLauncherCard
                location={location}
                title={name}
                appImage={appImage}
                handleAppCardClick={() => handleAppCardClick(location)}
              />
            </Grid>
          ))}
          <Grid item md={4} lg={3} xl={2} sm={6}>
            <AppLauncherCard
              title={"Launch Artwork Projection"}
              appImage={HDDReadyImage}
              handleAppCardClick={launchArtworkProjection}
            />
          </Grid>
        </Grid>
      </div>
    </div>
  );
};

export default AppLauncher;
